module.exports = __webpack_public_path__ + "images/kihnu/android-icon-48x48.png";